import React from 'react';
import { GenericFormPage } from '../../../components/generic';
import { useDepartment, Department } from './useData';
import { moduleConfig, getInitialFormData, mapItemToFormData } from './config';

const Form: React.FC = () => (
  <GenericFormPage<Department>
    useData={useDepartment}
    config={{
      ...moduleConfig,
      getInitialFormData,
      mapItemToFormData,
    }}
  />
);

export default Form;
